export const baseURL = process.env.NODE_ENV === 'production' ? '/api' : '/api';
export const loginUrl = 'https://sso.orks.com.cn?return_uri=https://erp2.oricos.cn';
console.log('process.env.NODE_ENV:',process.env.NODE_ENV)